import { useQuery } from '@apollo/client'
import { GetUserTagsDocument } from '../../../../../graphql/generated'
import useAlerts from '../../../hooks/useAlerts'

export default function useGetUserTags(tagPattern: string) {
  const { createAlert } = useAlerts()
  const variables = { tagPattern }
  const { data, loading, error } = useQuery(GetUserTagsDocument, {
    variables,
    onError: () => {
      createAlert('There was a problem retrieving tags.')
    }
  })

  const tags = data?.getUserTags || []
  return { tags, loading, error }
}
